import { render, staticRenderFns } from "./billTag.vue?vue&type=template&id=0401e182&"
import script from "./billTag.vue?vue&type=script&lang=js&"
export * from "./billTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports